import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import React from 'react'
import ReactDOM from 'react-dom/client'

import App from './App'
import { ErrorBoundary } from './components/ErrorBoundary'
import './index.css'
import { queryClient } from './lib/queryClient'
import axios from 'axios'
import { apiClient, configureApi, publicApiClient } from './services/api'
import { installMockAdapter } from './services/mockApi'
import { useAuthStore } from './stores/authStore'
import { useClientStore } from './stores/clientStore'

if (import.meta.env.VITE_USE_MOCK === 'true') {
  installMockAdapter(apiClient)
  installMockAdapter(publicApiClient)
  installMockAdapter(axios)
  console.info('[mock] API mock adapter installed')
}

configureApi({
  getAccessToken: () => useAuthStore.getState().accessToken,
  setAccessToken: (token) => useAuthStore.getState().setAccessToken(token),
  getCurrentClientId: () => useClientStore.getState().currentClientId,
  onSessionLost: () => {
    useAuthStore.getState().clear()
    useClientStore.getState().clear()
    queryClient.clear()
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <App />
        {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
)
